import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { getCourseCategory } from '../../../LambdaFunctions/shared/courseCategories';
import { publicLocalizer, wallDate } from './publicCalendarModel';

// react-bootstrap 1.0 beta forwards aria props to the inner document and can
// hide the dialog itself while mounting its portal. Repair the dialog node.
function exposeDialog(node) {
  node.removeAttribute('aria-hidden');
  node.setAttribute('aria-labelledby', 'public-lesson-details-title');
}

function focusDialog(node) {
  exposeDialog(node);
  node.querySelector('button').focus();
}

function trapDialogTab(event) {
  if (event.key !== 'Tab') return;
  const buttons = event.currentTarget.querySelectorAll('button:not([disabled])');
  const first = buttons[0];
  const last = buttons[buttons.length - 1];
  if (event.shiftKey && event.target === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && event.target === last) {
    event.preventDefault();
    first.focus();
  }
}

export default function PublicLessonDetailsModal({ event, onHide, onExited }) {
  const { t, i18n } = useTranslation();
  const lesson = event && event.lesson;
  const category = lesson && getCourseCategory(lesson.categoryId);
  const culture = i18n.language.startsWith('en') ? 'en' : 'pl';
  const unknown = t('public:timetable.notProvided');
  return (
    <Modal
      show={Boolean(event)}
      onHide={onHide}
      onExited={onExited}
      onEntering={exposeDialog}
      onEntered={focusDialog}
      onKeyDown={trapDialogTab}
      centered
      className="public-lesson-modal"
    >
      <Modal.Header closeButton closeLabel={t('common:close')}>
        <Modal.Title id="public-lesson-details-title">{t('public:timetable.lessonDetails')}</Modal.Title>
      </Modal.Header>
      {lesson && (
        <Modal.Body>
          {category && <p className="public-lesson-category" style={{ backgroundColor: category.color }}>{t(category.labelKey)}</p>}
          <p className="font-weight-bold">{publicLocalizer.format(event.start, 'EEEE, d.MM.yyyy', culture)} · {lesson.startTime}–{lesson.endTime}</p>
          <dl className="public-lesson-facts">
            <dt>{t('public:timetable.teacher')}</dt><dd>{lesson.teacherName || unknown}</dd>
            <dt>{t('public:timetable.courseStart')}</dt>
            <dd>{lesson.courseStartDate ? publicLocalizer.format(wallDate(lesson.courseStartDate), 'd.MM.yyyy', culture) : unknown}</dd>
            <dt>{t('public:timetable.participants')}</dt><dd>{Number.isInteger(lesson.participantCount) ? lesson.participantCount : unknown}</dd>
            <dt>{t('public:timetable.duration')}</dt>
            <dd>{Number.isInteger(lesson.durationMinutes) ? t('public:timetable.minutes', { count: lesson.durationMinutes }) : unknown}</dd>
            <dt>{t('public:timetable.lessonType')}</dt>
            <dd>{t(`public:timetable.types.${['individual', 'pair', 'trio', 'group'].includes(lesson.lessonType) ? lesson.lessonType : 'unknown'}`)}</dd>
          </dl>
          {lesson.level && <p>{t('public:timetable.level', { level: lesson.level })}</p>}
          <p className="font-weight-bold mb-0">{t(`public:timetable.${lesson.availability}`)}</p>
        </Modal.Body>
      )}
      <Modal.Footer><button type="button" className="btn manage-teal-button" onClick={onHide}>{t('common:close')}</button></Modal.Footer>
    </Modal>
  );
}

PublicLessonDetailsModal.propTypes = { event: PropTypes.object, onHide: PropTypes.func.isRequired, onExited: PropTypes.func.isRequired };
PublicLessonDetailsModal.defaultProps = { event: null };
